import {scheduleTrackingTask} from "../../../tracking/utils/schedule_tracking_task";
import {getCityLink} from "../utils/get_city_link";
import {ITransactionPriceRow} from "../utils/get_transaction_price_rows";
import {trackPricesHubButtonClick} from "./track_prices_hub_button_click";

/** One row of the transaction prices section opens the city page from several controls - all of them report the same click. */
export const trackPricesHubPlaceClick = (row: ITransactionPriceRow) => {
    scheduleTrackingTask(() =>
        trackPricesHubButtonClick({
            buttonName: "rp_apartment_prices_place",
            value: row.name,
            buttonLink: getCityLink(row.slug)
        })
    );
};
import {scheduleTrackingTask} from "../../../tracking/utils/schedule_tracking_task";
import {getCityLink} from "../utils/get_city_link";
import {ITransactionPriceRow} from "../utils/get_transaction_price_rows";
import {trackPricesHubButtonClick} from "./track_prices_hub_button_click";

/** One row of the transaction prices section opens the city page from several controls - all of them report the same click. */
export const trackPricesHubPlaceClick = (row: ITransactionPriceRow) => {
    scheduleTrackingTask(() =>
        trackPricesHubButtonClick({
            buttonName: "rp_apartment_prices_place",
            value: row.name,
            buttonLink: getCityLink(row.slug)
        })
    );
};
